<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModal">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Cargar fórmulas
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="mt-6" no-gutters>
            <v-col xl="12" lg="12" md="12" sm="10" cols="12">
              <v-row justify="start" no-gutters class="ml-lg-7 ml-xl-7">
                <div class="grey--text text--darken-3">
                  Tienes productos formulados en el carrito, por favor carga la fórmulas
                </div>
              </v-row>
            </v-col>
          </v-row>
          <formula-upload-form @close="formulaUploaded" :showAction="true"></formula-upload-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import FormulaUploadForm from '@/components/Formula/FormulaUploadForm'

export default {
  name: 'FormulaUploadModal',
  components: {
    FormulaUploadForm
  },
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    openModal () {
      this.isOpen = true
    },
    closeModal () {
      this.isOpen = false
    },
    formulaUploaded (chosenFiles) {
      this.$emit('formulaUploaded', chosenFiles)
      this.closeModal()
    }
  }
}
</script>

<style scoped>
  .light-text{
    font-size: 13px;
    color: #666;
    opacity: 0.7;
    line-height: 20px;
  }
</style>
